import { render, staticRenderFns } from "./BucketFiltersTab.vue?vue&type=template&id=5cff1c0a"
import script from "./BucketFiltersTab.vue?vue&type=script&lang=js"
export * from "./BucketFiltersTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports